<template>
    <div>
        <div v-if="activeOnboarding && activeOnboarding.members" class="pa-5">
            <div v-for="item in activeOnboarding.members" :key="`member_${item.id}`">
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Member ID" | t }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ item.id ? item.id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Name" | t }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ item.name ? item.name : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Identification code" | t }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ item.identification_code ? item.identification_code : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Entity type" | t }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ item.entity_type ? item.entity_type : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Role" | t }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ item.role ? item.role : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Country" | t }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ item.country ? item.country : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Is signer" | t }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ item.is_signer ? 'Yes' : 'No' }}
                    </v-col>
                </v-row>
                <v-row v-if="item.proxy_file_path">
                    <v-col class="col-item row-title" cols="3">{{ "Proxy file" | t }}</v-col>
                    <v-col class="col-item" cols="6">
                        <v-btn small color="bal-red" @click="handleDownloadFileClick(item)">
                            <v-icon>download</v-icon>
                            {{ "Download file" | t }}
                        </v-btn>
                    </v-col>
                </v-row>
                <v-divider class="mb-3 mt-3"/>
            </div>
        </div>
        <div v-else class="pa-5">{{ "No data" | t }}</div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "members-view-tab",
    computed: {
        ...mapState('onboarding', ['activeOnboarding'])
    },
    data() {
        return {
            appUrl: null
        };
    },
    mounted() {
        this.appUrl = process.env.VUE_APP_URL;
    },
    methods: {
        handleDownloadFileClick(member) {
            if (member.proxy_file_path) {
                window.location = `${this.appUrl}/app/onboarding-download-file/?onboardingMemberId=${member.id}`;
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
